import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost } from '../client';
import { qk } from './keys';
import type { SupportMessage, SupportTicket, SupportTicketDetails } from '../types';

export function useSupportTickets() {
  return useQuery({
    queryKey: qk.supportTickets,
    queryFn: () => apiGet<SupportTicket[]>('/support/tickets'),
  });
}

export function useSupportTicket(id: string | null) {
  return useQuery({
    queryKey: qk.supportTicket(id ?? ''),
    queryFn: () => apiGet<SupportTicketDetails>(`/support/tickets/${id ?? ''}`),
    enabled: !!id,
  });
}

export function useCreateSupportTicket() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { subject: string; body: string; attachments_object_keys?: string[] }) =>
      apiPost<SupportTicket>('/support/tickets', body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.supportTickets });
    },
  });
}

export function useReplySupportTicket(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { body: string; attachments_object_keys?: string[] }) =>
      apiPost<SupportMessage>(`/support/tickets/${id}/messages`, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.supportTicket(id) });
      qc.invalidateQueries({ queryKey: qk.supportTickets });
    },
  });
}

export function useCloseSupportTicket(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiPost<SupportTicket>(`/support/tickets/${id}/close`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: qk.supportTicket(id) });
      qc.invalidateQueries({ queryKey: qk.supportTickets });
    },
  });
}
